import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';
import { round } from 'mathjs';

// import { newRate } from '@tool/index';

const moDifferent = observable({
  list: <any[]>[],
  cityModal: false,
});

const newRate = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return 0;
  return round(value, digit);
};

const initDifferent = action((res: any) => {
  if (isEmpty(res)) return;

  let areaArr: any[] = [];
  let cityArr: any[] = [];

  let tempArea: any[] = [];
  res.map((item: any) => {
    if (item.city_area !== '全国') tempArea.push(item.city_area);
  });
  areaArr = uniq(tempArea);

  // console.log('区域 -- ', areaArr);
  areaArr.map((area: any) => {
    let temp: any[] = [];
    res.map((city: any) => {
      if (city.city_area === area) {
        temp.push({
          city: city.city,
          diff: newRate(city.diff_index),
          rate: city.diff_index_change,
        });
      }
    });
    cityArr.push({
      area: area,
      cityList: temp,
    });
  });

  moDifferent.list = cityArr;
});

const changeCity = action((value: string) => {});

export default moDifferent;
export {
  initDifferent, changeCity,
};
